module.exports = __webpack_public_path__ + "27673bd7080556384d5bc45b7423b34b.pdf";